import React, { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import { CopilotButton } from './copilot-button';

export const ButtonPortal: React.FC = () => {
  const [container, setContainer] = useState<HTMLElement | null>(null);

  useEffect(() => {
    // Find the container in the DOM
    const headerContainer = document.getElementById('copilot-button-container');
    if (headerContainer) {
      setContainer(headerContainer);
    }
    
    // Update if the DOM changes
    const observer = new MutationObserver(() => {
      const headerContainer = document.getElementById('copilot-button-container');
      if (headerContainer) {
        setContainer(headerContainer);
      }
    });
    
    observer.observe(document.body, { childList: true, subtree: true });
    
    return () => {
      observer.disconnect();
    };
  }, []);

  // If we have a container, render the button inside it using a portal
  if (container) {
    return createPortal(<CopilotButton />, container);
  }
  
  // Otherwise, render the button as a floating button
  return <CopilotButton className="fixed bottom-6 right-6" />;
};
